// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.bff1d69cd',
  revision: 'bff1d69cd',
  branch: 'develop',
  date: 'Thu, 10 Sep 2026 16:50:39 GMT'
};